var gr = Object.defineProperty, _r = Object.defineProperties;
var yr = Object.getOwnPropertyDescriptors;
var qn = Object.getOwnPropertySymbols;
var mr = Object.prototype.hasOwnProperty, Pr = Object.prototype.propertyIsEnumerable;
var Wn = (d, a, u) => a in d ? gr(d, a, { enumerable: !0, configurable: !0, writable: !0, value: u }) : d[a] = u, Xe = (d, a) => {
  for (var u in a || (a = {}))
    mr.call(a, u) && Wn(d, u, a[u]);
  if (qn)
    for (var u of qn(a))
      Pr.call(a, u) && Wn(d, u, a[u]);
  return d;
}, ze = (d, a) => _r(d, yr(a));
var Gt = (d, a, u) => Wn(d, typeof a != "symbol" ? a + "" : a, u);
var ct = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function xt(d) {
  return d && d.__esModule && Object.prototype.hasOwnProperty.call(d, "default") ? d.default : d;
}
var nn = { exports: {} };
nn.exports;
(function(d, a) {
  var u = 200, o = "Expected a function", f = "__lodash_hash_undefined__", c = 1, y = 2, m = 1 / 0, S = 9007199254740991, b = "[object Arguments]", O = "[object Array]", C = "[object Boolean]", T = "[object Date]", B = "[object Error]", L = "[object Function]", P = "[object GeneratorFunction]", Y = "[object Map]", $ = "[object Number]", E = "[object Object]", W = "[object Promise]", tt = "[object RegExp]", z = "[object Set]", G = "[object String]", et = "[object Symbol]", Q = "[object WeakMap]", nt = "[object ArrayBuffer]", N = "[object DataView]", I = "[object Float32Array]", rt = "[object Float64Array]", ft = "[object Int8Array]", w = "[object Int16Array]", g = "[object Int32Array]", h = "[object Uint8Array]", v = "[object Uint8ClampedArray]", p = "[object Uint16Array]", A = "[object Uint32Array]", _ = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, H = /^\w*$/, j = /^\./, U = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, q = /[\\^$.*+?()[\]{}|]/g, it = /\\(\\)?/g, vt = /^\[object .+?Constructor\]$/, _t = /^(?:0|[1-9]\d*)$/, F = {};
  F[I] = F[rt] = F[ft] = F[w] = F[g] = F[h] = F[v] = F[p] = F[A] = !0, F[b] = F[O] = F[nt] = F[C] = F[N] = F[T] = F[B] = F[L] = F[Y] = F[$] = F[E] = F[tt] = F[z] = F[G] = F[Q] = !1;
  var lt = typeof ct == "object" && ct && ct.Object === Object && ct, V = typeof self == "object" && self && self.Object === Object && self, Z = lt || V || Function("return this")(), yt = a && !a.nodeType && a, Pt = yt && !0 && d && !d.nodeType && d, Et = Pt && Pt.exports === yt, Tt = Et && lt.process, Kt = function() {
    try {
      return Tt && Tt.binding("util");
    } catch (t) {
    }
  }(), le = Kt && Kt.isTypedArray;
  function an(t, n, i, l) {
    for (var x = -1, D = t ? t.length : 0; ++x < D; ) {
      var R = t[x];
      n(l, R, i(R), t);
    }
    return l;
  }
  function sn(t, n) {
    for (var i = -1, l = t ? t.length : 0; ++i < l; )
      if (n(t[i], i, t))
        return !0;
    return !1;
  }
  function Jt(t) {
    return function(n) {
      return n == null ? void 0 : n[t];
    };
  }
  function de(t, n) {
    for (var i = -1, l = Array(t); ++i < t; )
      l[i] = n(i);
    return l;
  }
  function xe(t) {
    return function(n) {
      return t(n);
    };
  }
  function Te(t, n) {
    return t == null ? void 0 : t[n];
  }
  function bt(t) {
    var n = !1;
    if (t != null && typeof t.toString != "function")
      try {
        n = !!(t + "");
      } catch (i) {
      }
    return n;
  }
  function Xt(t) {
    var n = -1, i = Array(t.size);
    return t.forEach(function(l, x) {
      i[++n] = [x, l];
    }), i;
  }
  function on(t, n) {
    return function(i) {
      return t(n(i));
    };
  }
  function Le(t) {
    var n = -1, i = Array(t.size);
    return t.forEach(function(l) {
      i[++n] = l;
    }), i;
  }
  var Oe = Array.prototype, $e = Function.prototype, zt = Object.prototype, he = Z["__core-js_shared__"], Ie = function() {
    var t = /[^.]+$/.exec(he && he.keys && he.keys.IE_PROTO || "");
    return t ? "Symbol(src)_1." + t : "";
  }(), Ce = $e.toString, Dt = zt.hasOwnProperty, Bt = zt.toString, un = RegExp(
    "^" + Ce.call(Dt).replace(q, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), Vt = Z.Symbol, Nt = Z.Uint8Array, pe = zt.propertyIsEnumerable, ge = Oe.splice, _e = on(Object.keys, Object), Lt = It(Z, "DataView"), Zt = It(Z, "Map"), ye = It(Z, "Promise"), me = It(Z, "Set"), Pe = It(Z, "WeakMap"), Wt = It(Object, "create"), Ee = s(Lt), Be = s(Zt), Ot = s(ye), cn = s(me), fn = s(Pe), kt = Vt ? Vt.prototype : void 0, De = kt ? kt.valueOf : void 0, Ne = kt ? kt.toString : void 0;
  function ut(t) {
    var n = -1, i = t ? t.length : 0;
    for (this.clear(); ++n < i; ) {
      var l = t[n];
      this.set(l[0], l[1]);
    }
  }
  function ln() {
    this.__data__ = Wt ? Wt(null) : {};
  }
  function dn(t) {
    return this.has(t) && delete this.__data__[t];
  }
  function hn(t) {
    var n = this.__data__;
    if (Wt) {
      var i = n[t];
      return i === f ? void 0 : i;
    }
    return Dt.call(n, t) ? n[t] : void 0;
  }
  function pn(t) {
    var n = this.__data__;
    return Wt ? n[t] !== void 0 : Dt.call(n, t);
  }
  function gn(t, n) {
    var i = this.__data__;
    return i[t] = Wt && n === void 0 ? f : n, this;
  }
  ut.prototype.clear = ln, ut.prototype.delete = dn, ut.prototype.get = hn, ut.prototype.has = pn, ut.prototype.set = gn;
  function dt(t) {
    var n = -1, i = t ? t.length : 0;
    for (this.clear(); ++n < i; ) {
      var l = t[n];
      this.set(l[0], l[1]);
    }
  }
  function _n() {
    this.__data__ = [];
  }
  function yn(t) {
    var n = this.__data__, i = ne(n, t);
    if (i < 0)
      return !1;
    var l = n.length - 1;
    return i == l ? n.pop() : ge.call(n, i, 1), !0;
  }
  function mn(t) {
    var n = this.__data__, i = ne(n, t);
    return i < 0 ? void 0 : n[i][1];
  }
  function Pn(t) {
    return ne(this.__data__, t) > -1;
  }
  function Dn(t, n) {
    var i = this.__data__, l = ne(i, t);
    return l < 0 ? i.push([t, n]) : i[l][1] = n, this;
  }
  dt.prototype.clear = _n, dt.prototype.delete = yn, dt.prototype.get = mn, dt.prototype.has = Pn, dt.prototype.set = Dn;
  function ht(t) {
    var n = -1, i = t ? t.length : 0;
    for (this.clear(); ++n < i; ) {
      var l = t[n];
      this.set(l[0], l[1]);
    }
  }
  function vn() {
    this.__data__ = {
      hash: new ut(),
      map: new (Zt || dt)(),
      string: new ut()
    };
  }
  function bn(t) {
    return ie(this, t).delete(t);
  }
  function Mn(t) {
    return ie(this, t).get(t);
  }
  function Yn(t) {
    return ie(this, t).has(t);
  }
  function wn(t, n) {
    return ie(this, t).set(t, n), this;
  }
  ht.prototype.clear = vn, ht.prototype.delete = bn, ht.prototype.get = Mn, ht.prototype.has = Yn, ht.prototype.set = wn;
  function te(t) {
    var n = -1, i = t ? t.length : 0;
    for (this.__data__ = new ht(); ++n < i; )
      this.add(t[n]);
  }
  function Re(t) {
    return this.__data__.set(t, f), this;
  }
  function ee(t) {
    return this.__data__.has(t);
  }
  te.prototype.add = te.prototype.push = Re, te.prototype.has = ee;
  function wt(t) {
    this.__data__ = new dt(t);
  }
  function ve() {
    this.__data__ = new dt();
  }
  function An(t) {
    return this.__data__.delete(t);
  }
  function Sn(t) {
    return this.__data__.get(t);
  }
  function xn(t) {
    return this.__data__.has(t);
  }
  function Tn(t, n) {
    var i = this.__data__;
    if (i instanceof dt) {
      var l = i.__data__;
      if (!Zt || l.length < u - 1)
        return l.push([t, n]), this;
      i = this.__data__ = new ht(l);
    }
    return i.set(t, n), this;
  }
  wt.prototype.clear = ve, wt.prototype.delete = An, wt.prototype.get = Sn, wt.prototype.has = xn, wt.prototype.set = Tn;
  function Ln(t, n) {
    var i = J(t) || pt(t) ? de(t.length, String) : [], l = i.length, x = !!l;
    for (var D in t)
      (n || Dt.call(t, D)) && !(x && (D == "length" || we(D, l))) && i.push(D);
    return i;
  }
  function ne(t, n) {
    for (var i = t.length; i--; )
      if (at(t[i][0], n))
        return i;
    return -1;
  }
  function be(t, n, i, l) {
    return On(t, function(x, D, R) {
      n(l, x, i(x), R);
    }), l;
  }
  var On = jn(In), $n = Ge();
  function In(t, n) {
    return t && $n(t, n, Qe);
  }
  function Fe(t, n) {
    n = ae(n, t) ? [n] : je(n);
    for (var i = 0, l = n.length; t != null && i < l; )
      t = t[r(n[i++])];
    return i && i == l ? t : void 0;
  }
  function Cn(t) {
    return Bt.call(t);
  }
  function En(t, n) {
    return t != null && n in Object(t);
  }
  function Me(t, n, i, l, x) {
    return t === n ? !0 : t == null || n == null || !Qt(t) && !Ht(n) ? t !== t && n !== n : He(t, n, Me, i, l, x);
  }
  function He(t, n, i, l, x, D) {
    var R = J(t), K = J(n), X = O, st = O;
    R || (X = St(t), X = X == b ? E : X), K || (st = St(n), st = st == b ? E : st);
    var gt = X == E && !bt(t), mt = st == E && !bt(n), ot = X == st;
    if (ot && !gt)
      return D || (D = new wt()), R || cr(t) ? At(t, n, i, l, x, D) : Gn(t, n, X, i, l, x, D);
    if (!(x & y)) {
      var Mt = gt && Dt.call(t, "__wrapped__"), Yt = mt && Dt.call(n, "__wrapped__");
      if (Mt || Yt) {
        var jt = Mt ? t.value() : t, Ct = Yt ? n.value() : n;
        return D || (D = new wt()), i(jt, Ct, l, x, D);
      }
    }
    return ot ? (D || (D = new wt()), Ke(t, n, i, l, x, D)) : !1;
  }
  function Bn(t, n, i, l) {
    var x = i.length, D = x, R = !l;
    if (t == null)
      return !D;
    for (t = Object(t); x--; ) {
      var K = i[x];
      if (R && K[2] ? K[1] !== t[K[0]] : !(K[0] in t))
        return !1;
    }
    for (; ++x < D; ) {
      K = i[x];
      var X = K[0], st = t[X], gt = K[1];
      if (R && K[2]) {
        if (st === void 0 && !(X in t))
          return !1;
      } else {
        var mt = new wt();
        if (l)
          var ot = l(st, gt, X, t, n, mt);
        if (!(ot === void 0 ? Me(gt, st, l, c | y, mt) : ot))
          return !1;
      }
    }
    return !0;
  }
  function Nn(t) {
    if (!Qt(t) || Zn(t))
      return !1;
    var n = Se(t) || bt(t) ? un : vt;
    return n.test(s(t));
  }
  function re(t) {
    return Ht(t) && ue(t.length) && !!F[Bt.call(t)];
  }
  function Rt(t) {
    return typeof t == "function" ? t : t == null ? hr : typeof t == "object" ? J(t) ? Rn(t[0], t[1]) : $t(t) : pr(t);
  }
  function Ue(t) {
    if (!Ae(t))
      return _e(t);
    var n = [];
    for (var i in Object(t))
      Dt.call(t, i) && i != "constructor" && n.push(i);
    return n;
  }
  function $t(t) {
    var n = Ye(t);
    return n.length == 1 && n[0][2] ? We(n[0][0], n[0][1]) : function(i) {
      return i === t || Bn(i, t, n);
    };
  }
  function Rn(t, n) {
    return ae(t) && Ze(n) ? We(r(t), n) : function(i) {
      var l = lr(i, t);
      return l === void 0 && l === n ? dr(i, t) : Me(n, l, void 0, c | y);
    };
  }
  function Fn(t) {
    return function(n) {
      return Fe(n, t);
    };
  }
  function Hn(t) {
    if (typeof t == "string")
      return t;
    if (Ut(t))
      return Ne ? Ne.call(t) : "";
    var n = t + "";
    return n == "0" && 1 / t == -m ? "-0" : n;
  }
  function je(t) {
    return J(t) ? t : e(t);
  }
  function Un(t, n) {
    return function(i, l) {
      var x = J(i) ? an : be, D = n ? n() : {};
      return x(i, t, Rt(l), D);
    };
  }
  function jn(t, n) {
    return function(i, l) {
      if (i == null)
        return i;
      if (!oe(i))
        return t(i, l);
      for (var x = i.length, D = n ? x : -1, R = Object(i); (n ? D-- : ++D < x) && l(R[D], D, R) !== !1; )
        ;
      return i;
    };
  }
  function Ge(t) {
    return function(n, i, l) {
      for (var x = -1, D = Object(n), R = l(n), K = R.length; K--; ) {
        var X = R[t ? K : ++x];
        if (i(D[X], X, D) === !1)
          break;
      }
      return n;
    };
  }
  function At(t, n, i, l, x, D) {
    var R = x & y, K = t.length, X = n.length;
    if (K != X && !(R && X > K))
      return !1;
    var st = D.get(t);
    if (st && D.get(n))
      return st == n;
    var gt = -1, mt = !0, ot = x & c ? new te() : void 0;
    for (D.set(t, n), D.set(n, t); ++gt < K; ) {
      var Mt = t[gt], Yt = n[gt];
      if (l)
        var jt = R ? l(Yt, Mt, gt, n, t, D) : l(Mt, Yt, gt, t, n, D);
      if (jt !== void 0) {
        if (jt)
          continue;
        mt = !1;
        break;
      }
      if (ot) {
        if (!sn(n, function(Ct, qt) {
          if (!ot.has(qt) && (Mt === Ct || i(Mt, Ct, l, x, D)))
            return ot.add(qt);
        })) {
          mt = !1;
          break;
        }
      } else if (!(Mt === Yt || i(Mt, Yt, l, x, D))) {
        mt = !1;
        break;
      }
    }
    return D.delete(t), D.delete(n), mt;
  }
  function Gn(t, n, i, l, x, D, R) {
    switch (i) {
      case N:
        if (t.byteLength != n.byteLength || t.byteOffset != n.byteOffset)
          return !1;
        t = t.buffer, n = n.buffer;
      case nt:
        return !(t.byteLength != n.byteLength || !l(new Nt(t), new Nt(n)));
      case C:
      case T:
      case $:
        return at(+t, +n);
      case B:
        return t.name == n.name && t.message == n.message;
      case tt:
      case G:
        return t == n + "";
      case Y:
        var K = Xt;
      case z:
        var X = D & y;
        if (K || (K = Le), t.size != n.size && !X)
          return !1;
        var st = R.get(t);
        if (st)
          return st == n;
        D |= c, R.set(t, n);
        var gt = At(K(t), K(n), l, x, D, R);
        return R.delete(t), gt;
      case et:
        if (De)
          return De.call(t) == De.call(n);
    }
    return !1;
  }
  function Ke(t, n, i, l, x, D) {
    var R = x & y, K = Qe(t), X = K.length, st = Qe(n), gt = st.length;
    if (X != gt && !R)
      return !1;
    for (var mt = X; mt--; ) {
      var ot = K[mt];
      if (!(R ? ot in n : Dt.call(n, ot)))
        return !1;
    }
    var Mt = D.get(t);
    if (Mt && D.get(n))
      return Mt == n;
    var Yt = !0;
    D.set(t, n), D.set(n, t);
    for (var jt = R; ++mt < X; ) {
      ot = K[mt];
      var Ct = t[ot], qt = n[ot];
      if (l)
        var Qn = R ? l(qt, Ct, ot, n, t, D) : l(Ct, qt, ot, t, n, D);
      if (!(Qn === void 0 ? Ct === qt || i(Ct, qt, l, x, D) : Qn)) {
        Yt = !1;
        break;
      }
      jt || (jt = ot == "constructor");
    }
    if (Yt && !jt) {
      var qe = t.constructor, Je = n.constructor;
      qe != Je && "constructor" in t && "constructor" in n && !(typeof qe == "function" && qe instanceof qe && typeof Je == "function" && Je instanceof Je) && (Yt = !1);
    }
    return D.delete(t), D.delete(n), Yt;
  }
  function ie(t, n) {
    var i = t.__data__;
    return se(n) ? i[typeof n == "string" ? "string" : "hash"] : i.map;
  }
  function Ye(t) {
    for (var n = Qe(t), i = n.length; i--; ) {
      var l = n[i], x = t[l];
      n[i] = [l, x, Ze(x)];
    }
    return n;
  }
  function It(t, n) {
    var i = Te(t, n);
    return Nn(i) ? i : void 0;
  }
  var St = Cn;
  (Lt && St(new Lt(new ArrayBuffer(1))) != N || Zt && St(new Zt()) != Y || ye && St(ye.resolve()) != W || me && St(new me()) != z || Pe && St(new Pe()) != Q) && (St = function(t) {
    var n = Bt.call(t), i = n == E ? t.constructor : void 0, l = i ? s(i) : void 0;
    if (l)
      switch (l) {
        case Ee:
          return N;
        case Be:
          return Y;
        case Ot:
          return W;
        case cn:
          return z;
        case fn:
          return Q;
      }
    return n;
  });
  function Kn(t, n, i) {
    n = ae(n, t) ? [n] : je(n);
    for (var l, x = -1, R = n.length; ++x < R; ) {
      var D = r(n[x]);
      if (!(l = t != null && i(t, D)))
        break;
      t = t[D];
    }
    if (l)
      return l;
    var R = t ? t.length : 0;
    return !!R && ue(R) && we(D, R) && (J(t) || pt(t));
  }
  function we(t, n) {
    return n = n == null ? S : n, !!n && (typeof t == "number" || _t.test(t)) && t > -1 && t % 1 == 0 && t < n;
  }
  function ae(t, n) {
    if (J(t))
      return !1;
    var i = typeof t;
    return i == "number" || i == "symbol" || i == "boolean" || t == null || Ut(t) ? !0 : H.test(t) || !_.test(t) || n != null && t in Object(n);
  }
  function se(t) {
    var n = typeof t;
    return n == "string" || n == "number" || n == "symbol" || n == "boolean" ? t !== "__proto__" : t === null;
  }
  function Zn(t) {
    return !!Ie && Ie in t;
  }
  function Ae(t) {
    var n = t && t.constructor, i = typeof n == "function" && n.prototype || zt;
    return t === i;
  }
  function Ze(t) {
    return t === t && !Qt(t);
  }
  function We(t, n) {
    return function(i) {
      return i == null ? !1 : i[t] === n && (n !== void 0 || t in Object(i));
    };
  }
  var e = k(function(t) {
    t = fr(t);
    var n = [];
    return j.test(t) && n.push(""), t.replace(U, function(i, l, x, D) {
      n.push(x ? D.replace(it, "$1") : l || i);
    }), n;
  });
  function r(t) {
    if (typeof t == "string" || Ut(t))
      return t;
    var n = t + "";
    return n == "0" && 1 / t == -m ? "-0" : n;
  }
  function s(t) {
    if (t != null) {
      try {
        return Ce.call(t);
      } catch (n) {
      }
      try {
        return t + "";
      } catch (n) {
      }
    }
    return "";
  }
  var M = Un(function(t, n, i) {
    Dt.call(t, i) ? t[i].push(n) : t[i] = [n];
  });
  function k(t, n) {
    if (typeof t != "function" || n && typeof n != "function")
      throw new TypeError(o);
    var i = function() {
      var l = arguments, x = n ? n.apply(this, l) : l[0], D = i.cache;
      if (D.has(x))
        return D.get(x);
      var R = t.apply(this, l);
      return i.cache = D.set(x, R), R;
    };
    return i.cache = new (k.Cache || ht)(), i;
  }
  k.Cache = ht;
  function at(t, n) {
    return t === n || t !== t && n !== n;
  }
  function pt(t) {
    return Ft(t) && Dt.call(t, "callee") && (!pe.call(t, "callee") || Bt.call(t) == b);
  }
  var J = Array.isArray;
  function oe(t) {
    return t != null && ue(t.length) && !Se(t);
  }
  function Ft(t) {
    return Ht(t) && oe(t);
  }
  function Se(t) {
    var n = Qt(t) ? Bt.call(t) : "";
    return n == L || n == P;
  }
  function ue(t) {
    return typeof t == "number" && t > -1 && t % 1 == 0 && t <= S;
  }
  function Qt(t) {
    var n = typeof t;
    return !!t && (n == "object" || n == "function");
  }
  function Ht(t) {
    return !!t && typeof t == "object";
  }
  function Ut(t) {
    return typeof t == "symbol" || Ht(t) && Bt.call(t) == et;
  }
  var cr = le ? xe(le) : re;
  function fr(t) {
    return t == null ? "" : Hn(t);
  }
  function lr(t, n, i) {
    var l = t == null ? void 0 : Fe(t, n);
    return l === void 0 ? i : l;
  }
  function dr(t, n) {
    return t != null && Kn(t, n, En);
  }
  function Qe(t) {
    return oe(t) ? Ln(t) : Ue(t);
  }
  function hr(t) {
    return t;
  }
  function pr(t) {
    return ae(t) ? Jt(r(t)) : Fn(t);
  }
  d.exports = M;
})(nn, nn.exports);
var Dr = nn.exports;
const Jn = /* @__PURE__ */ xt(Dr);
var rn = { exports: {} };
rn.exports;
(function(d, a) {
  var u = 200, o = "__lodash_hash_undefined__", f = 9007199254740991, c = "[object Arguments]", y = "[object Array]", m = "[object Boolean]", S = "[object Date]", b = "[object Error]", O = "[object Function]", C = "[object GeneratorFunction]", T = "[object Map]", B = "[object Number]", L = "[object Object]", P = "[object Promise]", Y = "[object RegExp]", $ = "[object Set]", E = "[object String]", W = "[object Symbol]", tt = "[object WeakMap]", z = "[object ArrayBuffer]", G = "[object DataView]", et = "[object Float32Array]", Q = "[object Float64Array]", nt = "[object Int8Array]", N = "[object Int16Array]", I = "[object Int32Array]", rt = "[object Uint8Array]", ft = "[object Uint8ClampedArray]", w = "[object Uint16Array]", g = "[object Uint32Array]", h = /[\\^$.*+?()[\]{}|]/g, v = /\w*$/, p = /^\[object .+?Constructor\]$/, A = /^(?:0|[1-9]\d*)$/, _ = {};
  _[c] = _[y] = _[z] = _[G] = _[m] = _[S] = _[et] = _[Q] = _[nt] = _[N] = _[I] = _[T] = _[B] = _[L] = _[Y] = _[$] = _[E] = _[W] = _[rt] = _[ft] = _[w] = _[g] = !0, _[b] = _[O] = _[tt] = !1;
  var H = typeof ct == "object" && ct && ct.Object === Object && ct, j = typeof self == "object" && self && self.Object === Object && self, U = H || j || Function("return this")(), q = a && !a.nodeType && a, it = q && !0 && d && !d.nodeType && d, vt = it && it.exports === q;
  function _t(e, r) {
    return e.set(r[0], r[1]), e;
  }
  function F(e, r) {
    return e.add(r), e;
  }
  function lt(e, r) {
    for (var s = -1, M = e ? e.length : 0; ++s < M && r(e[s], s, e) !== !1; )
      ;
    return e;
  }
  function V(e, r) {
    for (var s = -1, M = r.length, k = e.length; ++s < M; )
      e[k + s] = r[s];
    return e;
  }
  function Z(e, r, s, M) {
    var k = -1, at = e ? e.length : 0;
    for (M && at && (s = e[++k]); ++k < at; )
      s = r(s, e[k], k, e);
    return s;
  }
  function yt(e, r) {
    for (var s = -1, M = Array(e); ++s < e; )
      M[s] = r(s);
    return M;
  }
  function Pt(e, r) {
    return e == null ? void 0 : e[r];
  }
  function Et(e) {
    var r = !1;
    if (e != null && typeof e.toString != "function")
      try {
        r = !!(e + "");
      } catch (s) {
      }
    return r;
  }
  function Tt(e) {
    var r = -1, s = Array(e.size);
    return e.forEach(function(M, k) {
      s[++r] = [k, M];
    }), s;
  }
  function Kt(e, r) {
    return function(s) {
      return e(r(s));
    };
  }
  function le(e) {
    var r = -1, s = Array(e.size);
    return e.forEach(function(M) {
      s[++r] = M;
    }), s;
  }
  var an = Array.prototype, sn = Function.prototype, Jt = Object.prototype, de = U["__core-js_shared__"], xe = function() {
    var e = /[^.]+$/.exec(de && de.keys && de.keys.IE_PROTO || "");
    return e ? "Symbol(src)_1." + e : "";
  }(), Te = sn.toString, bt = Jt.hasOwnProperty, Xt = Jt.toString, on = RegExp(
    "^" + Te.call(bt).replace(h, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), Le = vt ? U.Buffer : void 0, Oe = U.Symbol, $e = U.Uint8Array, zt = Kt(Object.getPrototypeOf, Object), he = Object.create, Ie = Jt.propertyIsEnumerable, Ce = an.splice, Dt = Object.getOwnPropertySymbols, Bt = Le ? Le.isBuffer : void 0, un = Kt(Object.keys, Object), Vt = Rt(U, "DataView"), Nt = Rt(U, "Map"), pe = Rt(U, "Promise"), ge = Rt(U, "Set"), _e = Rt(U, "WeakMap"), Lt = Rt(Object, "create"), Zt = At(Vt), ye = At(Nt), me = At(pe), Pe = At(ge), Wt = At(_e), Ee = Oe ? Oe.prototype : void 0, Be = Ee ? Ee.valueOf : void 0;
  function Ot(e) {
    var r = -1, s = e ? e.length : 0;
    for (this.clear(); ++r < s; ) {
      var M = e[r];
      this.set(M[0], M[1]);
    }
  }
  function cn() {
    this.__data__ = Lt ? Lt(null) : {};
  }
  function fn(e) {
    return this.has(e) && delete this.__data__[e];
  }
  function kt(e) {
    var r = this.__data__;
    if (Lt) {
      var s = r[e];
      return s === o ? void 0 : s;
    }
    return bt.call(r, e) ? r[e] : void 0;
  }
  function De(e) {
    var r = this.__data__;
    return Lt ? r[e] !== void 0 : bt.call(r, e);
  }
  function Ne(e, r) {
    var s = this.__data__;
    return s[e] = Lt && r === void 0 ? o : r, this;
  }
  Ot.prototype.clear = cn, Ot.prototype.delete = fn, Ot.prototype.get = kt, Ot.prototype.has = De, Ot.prototype.set = Ne;
  function ut(e) {
    var r = -1, s = e ? e.length : 0;
    for (this.clear(); ++r < s; ) {
      var M = e[r];
      this.set(M[0], M[1]);
    }
  }
  function ln() {
    this.__data__ = [];
  }
  function dn(e) {
    var r = this.__data__, s = ee(r, e);
    if (s < 0)
      return !1;
    var M = r.length - 1;
    return s == M ? r.pop() : Ce.call(r, s, 1), !0;
  }
  function hn(e) {
    var r = this.__data__, s = ee(r, e);
    return s < 0 ? void 0 : r[s][1];
  }
  function pn(e) {
    return ee(this.__data__, e) > -1;
  }
  function gn(e, r) {
    var s = this.__data__, M = ee(s, e);
    return M < 0 ? s.push([e, r]) : s[M][1] = r, this;
  }
  ut.prototype.clear = ln, ut.prototype.delete = dn, ut.prototype.get = hn, ut.prototype.has = pn, ut.prototype.set = gn;
  function dt(e) {
    var r = -1, s = e ? e.length : 0;
    for (this.clear(); ++r < s; ) {
      var M = e[r];
      this.set(M[0], M[1]);
    }
  }
  function _n() {
    this.__data__ = {
      hash: new Ot(),
      map: new (Nt || ut)(),
      string: new Ot()
    };
  }
  function yn(e) {
    return re(this, e).delete(e);
  }
  function mn(e) {
    return re(this, e).get(e);
  }
  function Pn(e) {
    return re(this, e).has(e);
  }
  function Dn(e, r) {
    return re(this, e).set(e, r), this;
  }
  dt.prototype.clear = _n, dt.prototype.delete = yn, dt.prototype.get = mn, dt.prototype.has = Pn, dt.prototype.set = Dn;
  function ht(e) {
    this.__data__ = new ut(e);
  }
  function vn() {
    this.__data__ = new ut();
  }
  function bn(e) {
    return this.__data__.delete(e);
  }
  function Mn(e) {
    return this.__data__.get(e);
  }
  function Yn(e) {
    return this.__data__.has(e);
  }
  function wn(e, r) {
    var s = this.__data__;
    if (s instanceof ut) {
      var M = s.__data__;
      if (!Nt || M.length < u - 1)
        return M.push([e, r]), this;
      s = this.__data__ = new dt(M);
    }
    return s.set(e, r), this;
  }
  ht.prototype.clear = vn, ht.prototype.delete = bn, ht.prototype.get = Mn, ht.prototype.has = Yn, ht.prototype.set = wn;
  function te(e, r) {
    var s = Ye(e) || ie(e) ? yt(e.length, String) : [], M = s.length, k = !!M;
    for (var at in e)
      (r || bt.call(e, at)) && !(k && (at == "length" || je(at, M))) && s.push(at);
    return s;
  }
  function Re(e, r, s) {
    var M = e[r];
    (!(bt.call(e, r) && Ke(M, s)) || s === void 0 && !(r in e)) && (e[r] = s);
  }
  function ee(e, r) {
    for (var s = e.length; s--; )
      if (Ke(e[s][0], r))
        return s;
    return -1;
  }
  function wt(e, r) {
    return e && He(r, Ae(r), e);
  }
  function ve(e, r, s, M, k, at, pt) {
    var J;
    if (M && (J = at ? M(e, k, at, pt) : M(e)), J !== void 0)
      return J;
    if (!se(e))
      return e;
    var oe = Ye(e);
    if (oe) {
      if (J = Rn(e), !r)
        return Me(e, J);
    } else {
      var Ft = $t(e), Se = Ft == O || Ft == C;
      if (Kn(e))
        return ne(e, r);
      if (Ft == L || Ft == c || Se && !at) {
        if (Et(e))
          return at ? e : {};
        if (J = Fn(Se ? {} : e), !r)
          return Bn(e, wt(J, e));
      } else {
        if (!_[Ft])
          return at ? e : {};
        J = Hn(e, Ft, ve, r);
      }
    }
    pt || (pt = new ht());
    var ue = pt.get(e);
    if (ue)
      return ue;
    if (pt.set(e, J), !oe)
      var Qt = s ? Nn(e) : Ae(e);
    return lt(Qt || e, function(Ht, Ut) {
      Qt && (Ut = Ht, Ht = e[Ut]), Re(J, Ut, ve(Ht, r, s, M, Ut, e, pt));
    }), J;
  }
  function An(e) {
    return se(e) ? he(e) : {};
  }
  function Sn(e, r, s) {
    var M = r(e);
    return Ye(e) ? M : V(M, s(e));
  }
  function xn(e) {
    return Xt.call(e);
  }
  function Tn(e) {
    if (!se(e) || jn(e))
      return !1;
    var r = we(e) || Et(e) ? on : p;
    return r.test(At(e));
  }
  function Ln(e) {
    if (!Ge(e))
      return un(e);
    var r = [];
    for (var s in Object(e))
      bt.call(e, s) && s != "constructor" && r.push(s);
    return r;
  }
  function ne(e, r) {
    if (r)
      return e.slice();
    var s = new e.constructor(e.length);
    return e.copy(s), s;
  }
  function be(e) {
    var r = new e.constructor(e.byteLength);
    return new $e(r).set(new $e(e)), r;
  }
  function On(e, r) {
    var s = r ? be(e.buffer) : e.buffer;
    return new e.constructor(s, e.byteOffset, e.byteLength);
  }
  function $n(e, r, s) {
    var M = r ? s(Tt(e), !0) : Tt(e);
    return Z(M, _t, new e.constructor());
  }
  function In(e) {
    var r = new e.constructor(e.source, v.exec(e));
    return r.lastIndex = e.lastIndex, r;
  }
  function Fe(e, r, s) {
    var M = r ? s(le(e), !0) : le(e);
    return Z(M, F, new e.constructor());
  }
  function Cn(e) {
    return Be ? Object(Be.call(e)) : {};
  }
  function En(e, r) {
    var s = r ? be(e.buffer) : e.buffer;
    return new e.constructor(s, e.byteOffset, e.length);
  }
  function Me(e, r) {
    var s = -1, M = e.length;
    for (r || (r = Array(M)); ++s < M; )
      r[s] = e[s];
    return r;
  }
  function He(e, r, s, M) {
    s || (s = {});
    for (var k = -1, at = r.length; ++k < at; ) {
      var pt = r[k], J = M ? M(s[pt], e[pt], pt, s, e) : void 0;
      Re(s, pt, J === void 0 ? e[pt] : J);
    }
    return s;
  }
  function Bn(e, r) {
    return He(e, Ue(e), r);
  }
  function Nn(e) {
    return Sn(e, Ae, Ue);
  }
  function re(e, r) {
    var s = e.__data__;
    return Un(r) ? s[typeof r == "string" ? "string" : "hash"] : s.map;
  }
  function Rt(e, r) {
    var s = Pt(e, r);
    return Tn(s) ? s : void 0;
  }
  var Ue = Dt ? Kt(Dt, Object) : Ze, $t = xn;
  (Vt && $t(new Vt(new ArrayBuffer(1))) != G || Nt && $t(new Nt()) != T || pe && $t(pe.resolve()) != P || ge && $t(new ge()) != $ || _e && $t(new _e()) != tt) && ($t = function(e) {
    var r = Xt.call(e), s = r == L ? e.constructor : void 0, M = s ? At(s) : void 0;
    if (M)
      switch (M) {
        case Zt:
          return G;
        case ye:
          return T;
        case me:
          return P;
        case Pe:
          return $;
        case Wt:
          return tt;
      }
    return r;
  });
  function Rn(e) {
    var r = e.length, s = e.constructor(r);
    return r && typeof e[0] == "string" && bt.call(e, "index") && (s.index = e.index, s.input = e.input), s;
  }
  function Fn(e) {
    return typeof e.constructor == "function" && !Ge(e) ? An(zt(e)) : {};
  }
  function Hn(e, r, s, M) {
    var k = e.constructor;
    switch (r) {
      case z:
        return be(e);
      case m:
      case S:
        return new k(+e);
      case G:
        return On(e, M);
      case et:
      case Q:
      case nt:
      case N:
      case I:
      case rt:
      case ft:
      case w:
      case g:
        return En(e, M);
      case T:
        return $n(e, M, s);
      case B:
      case E:
        return new k(e);
      case Y:
        return In(e);
      case $:
        return Fe(e, M, s);
      case W:
        return Cn(e);
    }
  }
  function je(e, r) {
    return r = r == null ? f : r, !!r && (typeof e == "number" || A.test(e)) && e > -1 && e % 1 == 0 && e < r;
  }
  function Un(e) {
    var r = typeof e;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? e !== "__proto__" : e === null;
  }
  function jn(e) {
    return !!xe && xe in e;
  }
  function Ge(e) {
    var r = e && e.constructor, s = typeof r == "function" && r.prototype || Jt;
    return e === s;
  }
  function At(e) {
    if (e != null) {
      try {
        return Te.call(e);
      } catch (r) {
      }
      try {
        return e + "";
      } catch (r) {
      }
    }
    return "";
  }
  function Gn(e) {
    return ve(e, !0, !0);
  }
  function Ke(e, r) {
    return e === r || e !== e && r !== r;
  }
  function ie(e) {
    return St(e) && bt.call(e, "callee") && (!Ie.call(e, "callee") || Xt.call(e) == c);
  }
  var Ye = Array.isArray;
  function It(e) {
    return e != null && ae(e.length) && !we(e);
  }
  function St(e) {
    return Zn(e) && It(e);
  }
  var Kn = Bt || We;
  function we(e) {
    var r = se(e) ? Xt.call(e) : "";
    return r == O || r == C;
  }
  function ae(e) {
    return typeof e == "number" && e > -1 && e % 1 == 0 && e <= f;
  }
  function se(e) {
    var r = typeof e;
    return !!e && (r == "object" || r == "function");
  }
  function Zn(e) {
    return !!e && typeof e == "object";
  }
  function Ae(e) {
    return It(e) ? te(e) : Ln(e);
  }
  function Ze() {
    return [];
  }
  function We() {
    return !1;
  }
  d.exports = Gn;
})(rn, rn.exports);
var vr = rn.exports;
const fe = /* @__PURE__ */ xt(vr);
var Vn = { exports: {} };
(function(d, a) {
  (function(u, o) {
    d.exports = o();
  })(ct, function() {
    var u = 1e3, o = 6e4, f = 36e5, c = "millisecond", y = "second", m = "minute", S = "hour", b = "day", O = "week", C = "month", T = "quarter", B = "year", L = "date", P = "Invalid Date", Y = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, $ = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, E = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(w) {
      var g = ["th", "st", "nd", "rd"], h = w % 100;
      return "[" + w + (g[(h - 20) % 10] || g[h] || g[0]) + "]";
    } }, W = function(w, g, h) {
      var v = String(w);
      return !v || v.length >= g ? w : "" + Array(g + 1 - v.length).join(h) + w;
    }, tt = { s: W, z: function(w) {
      var g = -w.utcOffset(), h = Math.abs(g), v = Math.floor(h / 60), p = h % 60;
      return (g <= 0 ? "+" : "-") + W(v, 2, "0") + ":" + W(p, 2, "0");
    }, m: function w(g, h) {
      if (g.date() < h.date()) return -w(h, g);
      var v = 12 * (h.year() - g.year()) + (h.month() - g.month()), p = g.clone().add(v, C), A = h - p < 0, _ = g.clone().add(v + (A ? -1 : 1), C);
      return +(-(v + (h - p) / (A ? p - _ : _ - p)) || 0);
    }, a: function(w) {
      return w < 0 ? Math.ceil(w) || 0 : Math.floor(w);
    }, p: function(w) {
      return { M: C, y: B, w: O, d: b, D: L, h: S, m, s: y, ms: c, Q: T }[w] || String(w || "").toLowerCase().replace(/s$/, "");
    }, u: function(w) {
      return w === void 0;
    } }, z = "en", G = {};
    G[z] = E;
    var et = "$isDayjsObject", Q = function(w) {
      return w instanceof rt || !(!w || !w[et]);
    }, nt = function w(g, h, v) {
      var p;
      if (!g) return z;
      if (typeof g == "string") {
        var A = g.toLowerCase();
        G[A] && (p = A), h && (G[A] = h, p = A);
        var _ = g.split("-");
        if (!p && _.length > 1) return w(_[0]);
      } else {
        var H = g.name;
        G[H] = g, p = H;
      }
      return !v && p && (z = p), p || !v && z;
    }, N = function(w, g) {
      if (Q(w)) return w.clone();
      var h = typeof g == "object" ? g : {};
      return h.date = w, h.args = arguments, new rt(h);
    }, I = tt;
    I.l = nt, I.i = Q, I.w = function(w, g) {
      return N(w, { locale: g.$L, utc: g.$u, x: g.$x, $offset: g.$offset });
    };
    var rt = function() {
      function w(h) {
        this.$L = nt(h.locale, null, !0), this.parse(h), this.$x = this.$x || h.x || {}, this[et] = !0;
      }
      var g = w.prototype;
      return g.parse = function(h) {
        this.$d = function(v) {
          var p = v.date, A = v.utc;
          if (p === null) return /* @__PURE__ */ new Date(NaN);
          if (I.u(p)) return /* @__PURE__ */ new Date();
          if (p instanceof Date) return new Date(p);
          if (typeof p == "string" && !/Z$/i.test(p)) {
            var _ = p.match(Y);
            if (_) {
              var H = _[2] - 1 || 0, j = (_[7] || "0").substring(0, 3);
              return A ? new Date(Date.UTC(_[1], H, _[3] || 1, _[4] || 0, _[5] || 0, _[6] || 0, j)) : new Date(_[1], H, _[3] || 1, _[4] || 0, _[5] || 0, _[6] || 0, j);
            }
          }
          return new Date(p);
        }(h), this.init();
      }, g.init = function() {
        var h = this.$d;
        this.$y = h.getFullYear(), this.$M = h.getMonth(), this.$D = h.getDate(), this.$W = h.getDay(), this.$H = h.getHours(), this.$m = h.getMinutes(), this.$s = h.getSeconds(), this.$ms = h.getMilliseconds();
      }, g.$utils = function() {
        return I;
      }, g.isValid = function() {
        return this.$d.toString() !== P;
      }, g.isSame = function(h, v) {
        var p = N(h);
        return this.startOf(v) <= p && p <= this.endOf(v);
      }, g.isAfter = function(h, v) {
        return N(h) < this.startOf(v);
      }, g.isBefore = function(h, v) {
        return this.endOf(v) < N(h);
      }, g.$g = function(h, v, p) {
        return I.u(h) ? this[v] : this.set(p, h);
      }, g.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, g.valueOf = function() {
        return this.$d.getTime();
      }, g.startOf = function(h, v) {
        var p = this, A = !!I.u(v) || v, _ = I.p(h), H = function(lt, V) {
          var Z = I.w(p.$u ? Date.UTC(p.$y, V, lt) : new Date(p.$y, V, lt), p);
          return A ? Z : Z.endOf(b);
        }, j = function(lt, V) {
          return I.w(p.toDate()[lt].apply(p.toDate("s"), (A ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(V)), p);
        }, U = this.$W, q = this.$M, it = this.$D, vt = "set" + (this.$u ? "UTC" : "");
        switch (_) {
          case B:
            return A ? H(1, 0) : H(31, 11);
          case C:
            return A ? H(1, q) : H(0, q + 1);
          case O:
            var _t = this.$locale().weekStart || 0, F = (U < _t ? U + 7 : U) - _t;
            return H(A ? it - F : it + (6 - F), q);
          case b:
          case L:
            return j(vt + "Hours", 0);
          case S:
            return j(vt + "Minutes", 1);
          case m:
            return j(vt + "Seconds", 2);
          case y:
            return j(vt + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, g.endOf = function(h) {
        return this.startOf(h, !1);
      }, g.$set = function(h, v) {
        var p, A = I.p(h), _ = "set" + (this.$u ? "UTC" : ""), H = (p = {}, p[b] = _ + "Date", p[L] = _ + "Date", p[C] = _ + "Month", p[B] = _ + "FullYear", p[S] = _ + "Hours", p[m] = _ + "Minutes", p[y] = _ + "Seconds", p[c] = _ + "Milliseconds", p)[A], j = A === b ? this.$D + (v - this.$W) : v;
        if (A === C || A === B) {
          var U = this.clone().set(L, 1);
          U.$d[H](j), U.init(), this.$d = U.set(L, Math.min(this.$D, U.daysInMonth())).$d;
        } else H && this.$d[H](j);
        return this.init(), this;
      }, g.set = function(h, v) {
        return this.clone().$set(h, v);
      }, g.get = function(h) {
        return this[I.p(h)]();
      }, g.add = function(h, v) {
        var p, A = this;
        h = Number(h);
        var _ = I.p(v), H = function(q) {
          var it = N(A);
          return I.w(it.date(it.date() + Math.round(q * h)), A);
        };
        if (_ === C) return this.set(C, this.$M + h);
        if (_ === B) return this.set(B, this.$y + h);
        if (_ === b) return H(1);
        if (_ === O) return H(7);
        var j = (p = {}, p[m] = o, p[S] = f, p[y] = u, p)[_] || 1, U = this.$d.getTime() + h * j;
        return I.w(U, this);
      }, g.subtract = function(h, v) {
        return this.add(-1 * h, v);
      }, g.format = function(h) {
        var v = this, p = this.$locale();
        if (!this.isValid()) return p.invalidDate || P;
        var A = h || "YYYY-MM-DDTHH:mm:ssZ", _ = I.z(this), H = this.$H, j = this.$m, U = this.$M, q = p.weekdays, it = p.months, vt = p.meridiem, _t = function(V, Z, yt, Pt) {
          return V && (V[Z] || V(v, A)) || yt[Z].slice(0, Pt);
        }, F = function(V) {
          return I.s(H % 12 || 12, V, "0");
        }, lt = vt || function(V, Z, yt) {
          var Pt = V < 12 ? "AM" : "PM";
          return yt ? Pt.toLowerCase() : Pt;
        };
        return A.replace($, function(V, Z) {
          return Z || function(yt) {
            switch (yt) {
              case "YY":
                return String(v.$y).slice(-2);
              case "YYYY":
                return I.s(v.$y, 4, "0");
              case "M":
                return U + 1;
              case "MM":
                return I.s(U + 1, 2, "0");
              case "MMM":
                return _t(p.monthsShort, U, it, 3);
              case "MMMM":
                return _t(it, U);
              case "D":
                return v.$D;
              case "DD":
                return I.s(v.$D, 2, "0");
              case "d":
                return String(v.$W);
              case "dd":
                return _t(p.weekdaysMin, v.$W, q, 2);
              case "ddd":
                return _t(p.weekdaysShort, v.$W, q, 3);
              case "dddd":
                return q[v.$W];
              case "H":
                return String(H);
              case "HH":
                return I.s(H, 2, "0");
              case "h":
                return F(1);
              case "hh":
                return F(2);
              case "a":
                return lt(H, j, !0);
              case "A":
                return lt(H, j, !1);
              case "m":
                return String(j);
              case "mm":
                return I.s(j, 2, "0");
              case "s":
                return String(v.$s);
              case "ss":
                return I.s(v.$s, 2, "0");
              case "SSS":
                return I.s(v.$ms, 3, "0");
              case "Z":
                return _;
            }
            return null;
          }(V) || _.replace(":", "");
        });
      }, g.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, g.diff = function(h, v, p) {
        var A, _ = this, H = I.p(v), j = N(h), U = (j.utcOffset() - this.utcOffset()) * o, q = this - j, it = function() {
          return I.m(_, j);
        };
        switch (H) {
          case B:
            A = it() / 12;
            break;
          case C:
            A = it();
            break;
          case T:
            A = it() / 3;
            break;
          case O:
            A = (q - U) / 6048e5;
            break;
          case b:
            A = (q - U) / 864e5;
            break;
          case S:
            A = q / f;
            break;
          case m:
            A = q / o;
            break;
          case y:
            A = q / u;
            break;
          default:
            A = q;
        }
        return p ? A : I.a(A);
      }, g.daysInMonth = function() {
        return this.endOf(C).$D;
      }, g.$locale = function() {
        return G[this.$L];
      }, g.locale = function(h, v) {
        if (!h) return this.$L;
        var p = this.clone(), A = nt(h, v, !0);
        return A && (p.$L = A), p;
      }, g.clone = function() {
        return I.w(this.$d, this);
      }, g.toDate = function() {
        return new Date(this.valueOf());
      }, g.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, g.toISOString = function() {
        return this.$d.toISOString();
      }, g.toString = function() {
        return this.$d.toUTCString();
      }, w;
    }(), ft = rt.prototype;
    return N.prototype = ft, [["$ms", c], ["$s", y], ["$m", m], ["$H", S], ["$W", b], ["$M", C], ["$y", B], ["$D", L]].forEach(function(w) {
      ft[w[1]] = function(g) {
        return this.$g(g, w[0], w[1]);
      };
    }), N.extend = function(w, g) {
      return w.$i || (w(g, rt, N), w.$i = !0), N;
    }, N.locale = nt, N.isDayjs = Q, N.unix = function(w) {
      return N(1e3 * w);
    }, N.en = G[z], N.Ls = G, N.p = {}, N;
  });
})(Vn);
var kn = Vn.exports;
const br = /* @__PURE__ */ xt(kn);
var tr = { exports: {} };
(function(d, a) {
  (function(u, o) {
    d.exports = o();
  })(ct, function() {
    var u = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, o = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, f = /\d\d/, c = /\d\d?/, y = /\d*[^-_:/,()\s\d]+/, m = {}, S = function(P) {
      return (P = +P) + (P > 68 ? 1900 : 2e3);
    }, b = function(P) {
      return function(Y) {
        this[P] = +Y;
      };
    }, O = [/[+-]\d\d:?(\d\d)?|Z/, function(P) {
      (this.zone || (this.zone = {})).offset = function(Y) {
        if (!Y || Y === "Z") return 0;
        var $ = Y.match(/([+-]|\d\d)/g), E = 60 * $[1] + (+$[2] || 0);
        return E === 0 ? 0 : $[0] === "+" ? -E : E;
      }(P);
    }], C = function(P) {
      var Y = m[P];
      return Y && (Y.indexOf ? Y : Y.s.concat(Y.f));
    }, T = function(P, Y) {
      var $, E = m.meridiem;
      if (E) {
        for (var W = 1; W <= 24; W += 1) if (P.indexOf(E(W, 0, Y)) > -1) {
          $ = W > 12;
          break;
        }
      } else $ = P === (Y ? "pm" : "PM");
      return $;
    }, B = { A: [y, function(P) {
      this.afternoon = T(P, !1);
    }], a: [y, function(P) {
      this.afternoon = T(P, !0);
    }], S: [/\d/, function(P) {
      this.milliseconds = 100 * +P;
    }], SS: [f, function(P) {
      this.milliseconds = 10 * +P;
    }], SSS: [/\d{3}/, function(P) {
      this.milliseconds = +P;
    }], s: [c, b("seconds")], ss: [c, b("seconds")], m: [c, b("minutes")], mm: [c, b("minutes")], H: [c, b("hours")], h: [c, b("hours")], HH: [c, b("hours")], hh: [c, b("hours")], D: [c, b("day")], DD: [f, b("day")], Do: [y, function(P) {
      var Y = m.ordinal, $ = P.match(/\d+/);
      if (this.day = $[0], Y) for (var E = 1; E <= 31; E += 1) Y(E).replace(/\[|\]/g, "") === P && (this.day = E);
    }], M: [c, b("month")], MM: [f, b("month")], MMM: [y, function(P) {
      var Y = C("months"), $ = (C("monthsShort") || Y.map(function(E) {
        return E.slice(0, 3);
      })).indexOf(P) + 1;
      if ($ < 1) throw new Error();
      this.month = $ % 12 || $;
    }], MMMM: [y, function(P) {
      var Y = C("months").indexOf(P) + 1;
      if (Y < 1) throw new Error();
      this.month = Y % 12 || Y;
    }], Y: [/[+-]?\d+/, b("year")], YY: [f, function(P) {
      this.year = S(P);
    }], YYYY: [/\d{4}/, b("year")], Z: O, ZZ: O };
    function L(P) {
      var Y, $;
      Y = P, $ = m && m.formats;
      for (var E = (P = Y.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(nt, N, I) {
        var rt = I && I.toUpperCase();
        return N || $[I] || u[I] || $[rt].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(ft, w, g) {
          return w || g.slice(1);
        });
      })).match(o), W = E.length, tt = 0; tt < W; tt += 1) {
        var z = E[tt], G = B[z], et = G && G[0], Q = G && G[1];
        E[tt] = Q ? { regex: et, parser: Q } : z.replace(/^\[|\]$/g, "");
      }
      return function(nt) {
        for (var N = {}, I = 0, rt = 0; I < W; I += 1) {
          var ft = E[I];
          if (typeof ft == "string") rt += ft.length;
          else {
            var w = ft.regex, g = ft.parser, h = nt.slice(rt), v = w.exec(h)[0];
            g.call(N, v), nt = nt.replace(v, "");
          }
        }
        return function(p) {
          var A = p.afternoon;
          if (A !== void 0) {
            var _ = p.hours;
            A ? _ < 12 && (p.hours += 12) : _ === 12 && (p.hours = 0), delete p.afternoon;
          }
        }(N), N;
      };
    }
    return function(P, Y, $) {
      $.p.customParseFormat = !0, P && P.parseTwoDigitYear && (S = P.parseTwoDigitYear);
      var E = Y.prototype, W = E.parse;
      E.parse = function(tt) {
        var z = tt.date, G = tt.utc, et = tt.args;
        this.$u = G;
        var Q = et[1];
        if (typeof Q == "string") {
          var nt = et[2] === !0, N = et[3] === !0, I = nt || N, rt = et[2];
          N && (rt = et[2]), m = this.$locale(), !nt && rt && (m = $.Ls[rt]), this.$d = function(h, v, p) {
            try {
              if (["x", "X"].indexOf(v) > -1) return new Date((v === "X" ? 1e3 : 1) * h);
              var A = L(v)(h), _ = A.year, H = A.month, j = A.day, U = A.hours, q = A.minutes, it = A.seconds, vt = A.milliseconds, _t = A.zone, F = /* @__PURE__ */ new Date(), lt = j || (_ || H ? 1 : F.getDate()), V = _ || F.getFullYear(), Z = 0;
              _ && !H || (Z = H > 0 ? H - 1 : F.getMonth());
              var yt = U || 0, Pt = q || 0, Et = it || 0, Tt = vt || 0;
              return _t ? new Date(Date.UTC(V, Z, lt, yt, Pt, Et, Tt + 60 * _t.offset * 1e3)) : p ? new Date(Date.UTC(V, Z, lt, yt, Pt, Et, Tt)) : new Date(V, Z, lt, yt, Pt, Et, Tt);
            } catch (Kt) {
              return /* @__PURE__ */ new Date("");
            }
          }(z, Q, G), this.init(), rt && rt !== !0 && (this.$L = this.locale(rt).$L), I && z != this.format(Q) && (this.$d = /* @__PURE__ */ new Date("")), m = {};
        } else if (Q instanceof Array) for (var ft = Q.length, w = 1; w <= ft; w += 1) {
          et[1] = Q[w - 1];
          var g = $.apply(this, et);
          if (g.isValid()) {
            this.$d = g.$d, this.$L = g.$L, this.init();
            break;
          }
          w === ft && (this.$d = /* @__PURE__ */ new Date(""));
        }
        else W.call(this, tt);
      };
    };
  });
})(tr);
var Mr = tr.exports;
const Yr = /* @__PURE__ */ xt(Mr);
var er = { exports: {} };
(function(d, a) {
  (function(u, o) {
    d.exports = o();
  })(ct, function() {
    return function(u, o) {
      o.prototype.isSameOrBefore = function(f, c) {
        return this.isSame(f, c) || this.isBefore(f, c);
      };
    };
  });
})(er);
var wr = er.exports;
const Ar = /* @__PURE__ */ xt(wr);
var nr = { exports: {} };
(function(d, a) {
  (function(u, o) {
    d.exports = o();
  })(ct, function() {
    return function(u, o) {
      o.prototype.isSameOrAfter = function(f, c) {
        return this.isSame(f, c) || this.isAfter(f, c);
      };
    };
  });
})(nr);
var Sr = nr.exports;
const xr = /* @__PURE__ */ xt(Sr);
var rr = { exports: {} };
(function(d, a) {
  (function(u, o) {
    d.exports = o();
  })(ct, function() {
    return function(u, o, f) {
      o.prototype.isBetween = function(c, y, m, S) {
        var b = f(c), O = f(y), C = (S = S || "()")[0] === "(", T = S[1] === ")";
        return (C ? this.isAfter(b, m) : !this.isBefore(b, m)) && (T ? this.isBefore(O, m) : !this.isAfter(O, m)) || (C ? this.isBefore(b, m) : !this.isAfter(b, m)) && (T ? this.isAfter(O, m) : !this.isBefore(O, m));
      };
    };
  });
})(rr);
var Tr = rr.exports;
const Lr = /* @__PURE__ */ xt(Tr);
var ir = { exports: {} };
(function(d, a) {
  (function(u, o) {
    d.exports = o();
  })(ct, function() {
    var u = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" };
    return function(o, f, c) {
      var y = f.prototype, m = y.format;
      c.en.formats = u, y.format = function(S) {
        S === void 0 && (S = "YYYY-MM-DDTHH:mm:ssZ");
        var b = this.$locale().formats, O = function(C, T) {
          return C.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(B, L, P) {
            var Y = P && P.toUpperCase();
            return L || T[P] || u[P] || T[Y].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function($, E, W) {
              return E || W.slice(1);
            });
          });
        }(S, b === void 0 ? {} : b);
        return m.call(this, O);
      };
    };
  });
})(ir);
var Or = ir.exports;
const $r = /* @__PURE__ */ xt(Or);
var ar = { exports: {} };
(function(d, a) {
  (function(u, o) {
    d.exports = o();
  })(ct, function() {
    return function(u, o, f) {
      var c = o.prototype, y = function(T) {
        var B, L = T.date, P = T.utc, Y = {};
        if (!((B = L) === null || B instanceof Date || B instanceof Array || c.$utils().u(B) || B.constructor.name !== "Object")) {
          if (!Object.keys(L).length) return /* @__PURE__ */ new Date();
          var $ = P ? f.utc() : f();
          Object.keys(L).forEach(function(nt) {
            var N, I;
            Y[N = nt, I = c.$utils().p(N), I === "date" ? "day" : I] = L[nt];
          });
          var E = Y.day || (Y.year || Y.month >= 0 ? 1 : $.date()), W = Y.year || $.year(), tt = Y.month >= 0 ? Y.month : Y.year || Y.day ? 0 : $.month(), z = Y.hour || 0, G = Y.minute || 0, et = Y.second || 0, Q = Y.millisecond || 0;
          return P ? new Date(Date.UTC(W, tt, E, z, G, et, Q)) : new Date(W, tt, E, z, G, et, Q);
        }
        return L;
      }, m = c.parse;
      c.parse = function(T) {
        T.date = y.bind(this)(T), m.bind(this)(T);
      };
      var S = c.set, b = c.add, O = c.subtract, C = function(T, B, L, P) {
        P === void 0 && (P = 1);
        var Y = Object.keys(B), $ = this;
        return Y.forEach(function(E) {
          $ = T.bind($)(B[E] * P, E);
        }), $;
      };
      c.set = function(T, B) {
        return B = B === void 0 ? T : B, T.constructor.name === "Object" ? C.bind(this)(function(L, P) {
          return S.bind(this)(P, L);
        }, B, T) : S.bind(this)(T, B);
      }, c.add = function(T, B) {
        return T.constructor.name === "Object" ? C.bind(this)(b, T, B) : b.bind(this)(T, B);
      }, c.subtract = function(T, B) {
        return T.constructor.name === "Object" ? C.bind(this)(b, T, B, -1) : O.bind(this)(T, B);
      };
    };
  });
})(ar);
var Ir = ar.exports;
const Cr = /* @__PURE__ */ xt(Ir);
var sr = { exports: {} };
(function(d, a) {
  (function(u, o) {
    d.exports = o();
  })(ct, function() {
    return function(u, o) {
      o.prototype.isLeapYear = function() {
        return this.$y % 4 == 0 && this.$y % 100 != 0 || this.$y % 400 == 0;
      };
    };
  });
})(sr);
var Er = sr.exports;
const Br = /* @__PURE__ */ xt(Er);
var Nr = { exports: {} };
(function(d, a) {
  (function(u, o) {
    d.exports = o(kn);
  })(ct, function(u) {
    function o(L) {
      return L && typeof L == "object" && "default" in L ? L : { default: L };
    }
    var f = o(u), c = "января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря".split("_"), y = "январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь".split("_"), m = "янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.".split("_"), S = "янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.".split("_"), b = /D[oD]?(\[[^[\]]*\]|\s)+MMMM?/;
    function O(L, P, Y) {
      var $, E;
      return Y === "m" ? P ? "минута" : "минуту" : L + " " + ($ = +L, E = { mm: P ? "минута_минуты_минут" : "минуту_минуты_минут", hh: "час_часа_часов", dd: "день_дня_дней", MM: "месяц_месяца_месяцев", yy: "год_года_лет" }[Y].split("_"), $ % 10 == 1 && $ % 100 != 11 ? E[0] : $ % 10 >= 2 && $ % 10 <= 4 && ($ % 100 < 10 || $ % 100 >= 20) ? E[1] : E[2]);
    }
    var C = function(L, P) {
      return b.test(P) ? c[L.month()] : y[L.month()];
    };
    C.s = y, C.f = c;
    var T = function(L, P) {
      return b.test(P) ? m[L.month()] : S[L.month()];
    };
    T.s = S, T.f = m;
    var B = { name: "ru", weekdays: "воскресенье_понедельник_вторник_среда_четверг_пятница_суббота".split("_"), weekdaysShort: "вск_пнд_втр_срд_чтв_птн_сбт".split("_"), weekdaysMin: "вс_пн_вт_ср_чт_пт_сб".split("_"), months: C, monthsShort: T, weekStart: 1, yearStart: 4, formats: { LT: "H:mm", LTS: "H:mm:ss", L: "DD.MM.YYYY", LL: "D MMMM YYYY г.", LLL: "D MMMM YYYY г., H:mm", LLLL: "dddd, D MMMM YYYY г., H:mm" }, relativeTime: { future: "через %s", past: "%s назад", s: "несколько секунд", m: O, mm: O, h: "час", hh: O, d: "день", dd: O, M: "месяц", MM: O, y: "год", yy: O }, ordinal: function(L) {
      return L;
    }, meridiem: function(L) {
      return L < 4 ? "ночи" : L < 12 ? "утра" : L < 17 ? "дня" : "вечера";
    } };
    return f.default.locale(B, null, !0), B;
  });
})(Nr);
class Rr {
  constructor(a = br) {
    this.dateLibrary = a, this.dateLibrary.locale("ru"), this.dateLibrary.extend(Yr), this.dateLibrary.extend(Ar), this.dateLibrary.extend(xr), this.dateLibrary.extend(Lr), this.dateLibrary.extend($r), this.dateLibrary.extend(Cr), this.dateLibrary.extend(Br);
  }
  get instance() {
    return this.dateLibrary;
  }
}
const ce = new Rr().instance, Ve = {
  inNormalYear: 0,
  inLeapYear: 0,
  common: 0
}, Xn = {
  AMOUNT: "depositAmount",
  PERIOD: "depositPeriod"
}, ke = 365, tn = 366, en = 28, Fr = {
  END: "end",
  QUARTAL: "quartal",
  MONTH: "month",
  YEAR: "year",
  HALF_YEAR: "half_year"
};
class or {
  constructor(a) {
    Gt(this, "depositRates", []);
    Gt(this, "depositOptions", {});
    Gt(this, "depositAmount", 0);
    Gt(this, "depositIncome", 0);
    Gt(this, "startRateDate");
    Gt(this, "intermediatePercents", fe(Ve));
    Gt(this, "intermediateDaysCount", fe(Ve));
    this.startRateDate = a ? ce(a, "DD.MM.YYYY") : ce();
  }
  init(a) {
    return a.flatMap((u) => {
      this.depositRates = u.rates, this.depositAmount = u.options.minDepositAmount, this.depositIncome = u.options.minDepositAmount, this.depositOptions = u.options;
      const o = this.calculate();
      return this.resetGlobalProps(), {
        depositId: u.id,
        calculationResult: o
      };
    });
  }
  resetGlobalProps() {
    this.depositRates = [], this.depositOptions = {}, this.depositAmount = 0, this.depositIncome = 0, this.startRateDate = ce(), this.intermediatePercents = fe(Ve), this.intermediateDaysCount = fe(Ve);
  }
  calculate() {
    const a = [];
    if (this.depositRates.forEach((f) => {
      const c = this.calculateInterestsByDepositRate(f);
      a.push(c);
    }), !a.length)
      return [];
    const u = this.calculateMgs(), o = parseFloat((a.at(-1).depositIncome - this.depositAmount).toFixed(2));
    return a.map((f) => ze(Xe({}, f), { mgs: u, totalDepositPercents: o }));
  }
  getPeriodsByRateValidity(a) {
    const u = ce(this.startRateDate).add(a, "month"), o = [], { periods: f } = this.generatePeriods({
      startRateDate: this.startRateDate,
      finishRateDate: u
    });
    if (o.push(...f), this.startRateDate = u, f.at(-1).daysUntilEndBillingPeriod < en) {
      const { periods: c } = this.generatePeriods({
        startRateDate: u,
        finishRateDate: u
      });
      o.push(...c), this.startRateDate = this.startRateDate.add(1, "month");
    }
    return o;
  }
  calculateInterestsByDepositRate({
    rate: a,
    rateValidityPeriod: u,
    transitionalRate: o,
    options: f
  }) {
    const c = this.getPeriodsByRateValidity(u), y = this.depositOptions.interestPayment === Fr.END || !(f != null && f.withPercents);
    let m;
    y ? m = this.calculateBillingPeriodPercents(c, a) : f.quartalPercents ? m = this.calculateBillingPeriodPercentsQuartally({ periods: c, rate: a, transitionalRate: o }) : f.halfyearPercents ? m = this.calculateBillingPeriodPercentsHalfYearly({ periods: c, rate: a, transitionalRate: o }) : m = this.calculateBillingPeriodPercentsMonthly({ periods: c, rate: a, transitionalRate: o });
    const {
      billingPeriodPercentsInLeapYear: S,
      billingPeriodPercentsInNormalYear: b,
      depositPercentAmount: O
    } = this.agregateBillingPeriodPercentsByYearType(m);
    y && (this.depositIncome += O), this.updateIntermediateProps({
      propName: "intermediatePercents",
      inNormalYear: b,
      inLeapYear: S,
      common: O
    });
    const {
      depositDaysInLeapYear: C,
      depositDaysInNormalYear: T,
      totalDaysUntilEndDepositPeriod: B
    } = this.agregateDepositDaysByYearType(c);
    this.updateIntermediateProps({
      propName: "intermediateDaysCount",
      inNormalYear: T,
      inLeapYear: C,
      common: B
    });
    const L = this.calculateActualDepositYield({
      billingPeriodPercentsInNormalYear: this.intermediatePercents.inNormalYear,
      billingPeriodPercentsInLeapYear: this.intermediatePercents.inLeapYear,
      totalDaysUntilEndDepositPeriod: this.intermediateDaysCount.common
    }), P = this.calculateFullDepositCost({
      billingPeriodPercentsInNormalYear: this.intermediatePercents.inNormalYear,
      billingPeriodPercentsInLeapYear: this.intermediatePercents.inLeapYear,
      totalDaysUntilEndDepositPeriod: this.intermediateDaysCount.common
    });
    return {
      depositIncome: parseFloat(this.depositIncome.toFixed(2)),
      depositPercentAmount: parseFloat(O.toFixed(2)),
      actualDepositYield: L,
      fullDepositCost: P
    };
  }
  calculateMgs() {
    const a = this.intermediatePercents.common / this.depositAmount * 100 / this.intermediateDaysCount.common, u = ke * this.intermediateDaysCount.inNormalYear, o = tn * this.intermediateDaysCount.inLeapYear, f = u + o, c = a * (f / this.intermediateDaysCount.common);
    return parseFloat(c.toFixed(3));
  }
  calculateFullDepositCost({
    billingPeriodPercentsInNormalYear: a,
    billingPeriodPercentsInLeapYear: u,
    totalDaysUntilEndDepositPeriod: o
  }) {
    const f = (S, b) => S / this.depositAmount * 100 / o * b, c = f(a, ke), y = f(u, tn), m = c + y;
    return parseFloat(m.toFixed(2));
  }
  calculateActualDepositYield({
    billingPeriodPercentsInNormalYear: a,
    billingPeriodPercentsInLeapYear: u,
    totalDaysUntilEndDepositPeriod: o
  }) {
    const f = (S, b) => S / this.depositAmount / o * b, c = f(a, ke), y = f(u, tn), m = (c + y) * 100;
    return parseFloat(m.toFixed(2));
  }
  updateIntermediateProps({ propName: a, inNormalYear: u, inLeapYear: o, common: f }) {
    this[a].inNormalYear += u, this[a].inLeapYear += o, this[a].common += f;
  }
  agregateBillingPeriodPercentsByYearType(a) {
    const {
      false: u = [],
      true: o = []
    } = Jn(a, "period.isLeapYear"), f = (S) => S.reduce((b, { billingPeriodPercent: O }) => b += O, 0), c = f(u), y = f(o), m = c + y;
    return {
      billingPeriodPercentsInNormalYear: c,
      billingPeriodPercentsInLeapYear: y,
      depositPercentAmount: m
    };
  }
  getPeriodPredicates({ periods: a, index: u }) {
    var m, S;
    const o = a[u].daysUntilEndBillingPeriod < en, f = o && ((m = a[u + 1]) == null ? void 0 : m.daysUntilEndBillingPeriod) < en, c = o && ((S = a[u - 1]) == null ? void 0 : S.daysUntilEndBillingPeriod) < en;
    return {
      isLastPeriod: u === a.length - 1,
      isTransitionPeriod: o,
      isTransitionPeriodStartDate: f,
      isTransitionPeriodLastDate: c
    };
  }
  calculateBillingPeriodPercentsMonthly({
    periods: a,
    rate: u,
    transitionalRate: o
  }) {
    let f = 0, c = u;
    return a.map((y, m) => {
      const {
        isLastPeriod: S,
        isTransitionPeriodStartDate: b,
        isTransitionPeriodLastDate: O
      } = this.getPeriodPredicates({ periods: a, index: m });
      O && o && (c = o);
      const C = this.calculateBillingPeriodPercent({
        period: y,
        depositRate: c
      }), T = {
        billingPeriodPercent: C,
        period: y
      };
      return b || o && !S ? (f += C, T) : O || o && S ? (this.depositIncome += C + f, T) : (this.depositIncome += C, T);
    });
  }
  calculateBillingPeriodPercentsQuartally({
    periods: a,
    rate: u,
    transitionalRate: o
  }) {
    let f = u, c = 0;
    return a.map((y, m) => {
      var C;
      y.periodQuartal !== ((C = a[m - 1]) == null ? void 0 : C.periodQuartal) && (this.depositIncome += c, c = 0);
      const {
        isLastPeriod: S,
        isTransitionPeriodLastDate: b
      } = this.getPeriodPredicates({ periods: a, index: m });
      b && o && (f = o);
      const O = this.calculateBillingPeriodPercent({
        period: y,
        depositRate: f
      });
      return c += O, S && (this.depositIncome += c), {
        billingPeriodPercent: O,
        period: y
      };
    });
  }
  calculateBillingPeriodPercentsHalfYearly({
    periods: a,
    rate: u,
    transitionalRate: o
  }) {
    let f = u, c = 0;
    return a.map((y, m) => {
      var C;
      y.halfYear !== ((C = a[m - 1]) == null ? void 0 : C.halfYear) && (this.depositIncome += c, c = 0);
      const {
        isLastPeriod: S,
        isTransitionPeriodLastDate: b
      } = this.getPeriodPredicates({ periods: a, index: m });
      b && o && (f = o);
      const O = this.calculateBillingPeriodPercent({
        period: y,
        depositRate: f
      });
      return c += O, S && (this.depositIncome += c), {
        billingPeriodPercent: O,
        period: y
      };
    });
  }
  calculateBillingPeriodPercents(a, u) {
    return a.map((o) => ({
      billingPeriodPercent: this.calculateBillingPeriodPercent({
        period: o,
        depositRate: u
      }),
      period: o
    }));
  }
  calculateBillingPeriodPercent({
    period: a,
    depositRate: u
  }) {
    const o = a.isLeapYear ? tn : ke;
    return this.depositIncome * u / 100 * a.daysUntilEndBillingPeriod / o;
  }
  agregateDepositDaysByYearType(a) {
    const {
      false: u = [],
      true: o = []
    } = Jn(a, "isLeapYear"), f = (S) => S.reduce((b, { daysUntilEndBillingPeriod: O }) => b += O, 0), c = f(u), y = f(o), m = c + y;
    return {
      depositDaysInNormalYear: c,
      depositDaysInLeapYear: y,
      totalDaysUntilEndDepositPeriod: m
    };
  }
  generatePeriods({ startRateDate: a, finishRateDate: u }) {
    const o = [];
    for (let f = a; f.isBefore(u, "month"); ) {
      const c = this.generateBillingPeriodDate(f, a), y = this.generateBillingPeriod({
        currendDate: f,
        nextDate: c,
        startRateDate: a
      });
      o.push(y), f = c;
    }
    return { periods: o };
  }
  generateBillingPeriod({ currendDate: a, nextDate: u, startRateDate: o }) {
    const f = u.diff(a, "day"), c = Math.ceil(u.diff(o, "month") / 3), y = Math.ceil(u.diff(o, "month") / 6);
    return {
      isLeapYear: u.isLeapYear(),
      date: a,
      daysUntilEndBillingPeriod: f,
      periodQuartal: Math.max(1, c),
      halfYear: y
    };
  }
  periodPredicates(a, u) {
    const o = a.isLeapYear(), f = u.isLeapYear();
    return {
      isLastDayInYear: a.diff(a.endOf("year"), "day") === 0,
      isNextYearIsLeap: !o && f,
      isNextYearIsNormal: o && !f
    };
  }
  generateEndYearDate(a) {
    return ce(a).endOf("year");
  }
  generateStartYearDate(a, u) {
    return ce(a).add(u.date(), "day");
  }
  generateBillingPeriodDate(a, u) {
    const o = a.add(1, "month"), {
      isLastDayInYear: f,
      isNextYearIsLeap: c,
      isNextYearIsNormal: y
    } = this.periodPredicates(a, o);
    return (c || y) && !f ? this.generateEndYearDate(a) : (c || y) && f ? this.generateStartYearDate(a, u) : o;
  }
}
function Hr({ filterOptions: d, deposits: a, startRateDate: u }) {
  const o = fe(a).reduce((y, m) => (jr(d, m) && y.push(Zr(d, m)), y), []), f = new or(u).init(o);
  if (!f.length)
    return [];
  const c = f.map(({ depositId: y, calculationResult: m }) => {
    const S = o.find(({ id: b }) => y === b);
    return ze(Xe({}, S), {
      calculationResult: m
    });
  });
  return ur(c);
}
function Ur(d) {
  if (!d || !d.length)
    throw new Error("Невозможно рассчитать лучший депозит (список депозитов пуст)!");
  if (d.length === 1)
    return zn(d[0]);
  const [a] = ur(fe(d));
  return zn(a);
}
function ur(d) {
  return d.sort((a, u) => {
    var m, S;
    const o = (m = a.calculationResult) == null ? void 0 : m.at(-1), f = (S = u.calculationResult) == null ? void 0 : S.at(-1), { depositIncome: c } = o != null ? o : {}, { depositIncome: y } = f != null ? f : {};
    return c && y ? c < y ? 1 : -1 : 1;
  });
}
function zn(d) {
  return ze(Xe({}, d), {
    bestBid: d.rates.at(-1).rate,
    bestYield: d.calculationResult.at(-1).actualDepositYield
  });
}
function jr(d, a) {
  return Object.entries(d).every(([u, o]) => u === Xn.PERIOD ? Gr(a, o) : u === Xn.AMOUNT ? Kr(a, o) : Object.prototype.hasOwnProperty.call(a.options, u) ? a.options[u] === o : !0);
}
function Gr(d, a) {
  const u = a <= d.options.maxDepositPeriod && d.options.maxDepositPeriod * 2 % a === 0;
  return (d.options.minDepositPeriod ? a >= d.options.minDepositPeriod : !0) && u;
}
function Kr(d, a) {
  var f;
  const u = a >= d.options.minDepositAmount, o = (f = d.options) != null && f.maxDepositAmount ? a <= d.options.maxDepositAmount : !0;
  return u && o;
}
function Zr(d, a) {
  let u = 0;
  return a.options.minDepositAmount = d.depositAmount, a.rates = a.rates.reduce((o, f) => (u += f.rateValidityPeriod, (d.depositPeriod >= u || d.minPeriod === a.options.minDepositPeriod && d.maxPeriod === a.options.maxDepositPeriod) && o.push(f), o), []), a;
}
function Qr({ deposits: d, startRateDate: a }) {
  return new or(a).init(d);
}
function qr({ deposits: d, filterOptions: a, startRateDate: u }) {
  return Hr({ deposits: d, filterOptions: a, startRateDate: u });
}
function Jr(d) {
  return Ur(d);
}
export {
  Qr as calculate,
  qr as filtrate,
  Jr as getBestDeposit
};
